import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.string,
};

const TagIconOutline = ({ color = '#0d84fe', size = '16', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={size}
    height={size}
    {...props}
  >
    <g>
      <path
        d="M11.4 2.5c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.8-2-2-2zm0 3.5c-.8 0-1.4-.6-1.4-1.4s.6-1.4 1.4-1.4 1.4.6 1.4 1.4S12.2 6 11.4 6z"
        fill={color}
      />
      <path
        d="M14.1 0L9.4.2c-.8 0-1.4.3-2 .8L.7 7.8c-.9.9-.9 2.3 0 3.2L5 15.3c.4.5 1 .7 1.6.7s1.2-.2 1.6-.7L15 8.5c.5-.5.8-1.2.9-1.9l.1-4.7c0-.5-.2-1-.5-1.4s-.9-.5-1.4-.5zm1.1 6.6c0 .6-.3 1.1-.7 1.5l-6.8 6.8c-.6.6-1.7.6-2.3 0l-4.3-4.3c-.6-.6-.6-1.7 0-2.3l6.8-6.8c.4-.4.9-.7 1.5-.7l4.7-.2c.4 0 .7.1.9.4.2.2.4.6.4.9l-.2 4.7z"
        fill={color}
      />
    </g>
  </svg>
);

TagIconOutline.propTypes = propTypes;

export default TagIconOutline;
